import { TripadvisorTestimonyLine } from 'Components/lines/tripadvisor-testimony-line/TripadvisorTestimonyLine';
export type CMSProps = {
  id: string;
  reviews: Array<{
    author: string;
    className?: string;
    date: string;
    fullCommentLink: string;
    link: CMSLink;
    onBy: string;
    stars: string;
    text: string;
  }>;
};
export default TripadvisorTestimonyLine;
